<template>
    <section class="container">
        <div class="row">
            <div class="col-lg-12">
                <h2 id="sounds">{{ title }}</h2>
            </div>
            <div class="col-lg-12 d-flex justify-content-center">
                <p class="sounds-description">{{ description }}</p>
            </div>
            <div class="col-lg-12">
                <iframe class="sounds-audio" height="300" scrolling="no" frameborder="no" allow="autoplay"
                    src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/1577041909&color=%23ff5500&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true&visual=true"></iframe>
                <div
                    style="font-size: 10px; color: #cccccc;line-break: anywhere;word-break: normal;overflow: hidden;white-space: nowrap;text-overflow: ellipsis; font-family: Interstate,Lucida Grande,Lucida Sans Unicode,Lucida Sans,Garuda,Verdana,Tahoma,sans-serif;font-weight: 100;">
                    <a href="https://soundcloud.com/alabama-tourism" title="Alabama Tourism" target="_blank" rel="noopener noreferrer"
                        style="color: #cccccc; text-decoration: none;">Alabama Tourism</a> · <a
                        href="https://soundcloud.com/alabama-tourism/sets/alabama-birding" title="Alabama Birding - Sounds of Happy"
                        target="_blank" rel="noopener noreferrer" style="color: #cccccc; text-decoration: none;">Alabama Birding - Sounds of Happy</a></div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
  name: 'soundsofhappy',
  props: {
    title: {
      type: String,
    },
    description: {
      type: String,
    },
  },
};
</script>

<style scoped>
section {
    margin-top: 75px;
    margin-bottom: 75px;
}

h2 {
    line-height: 60px;
}
.sounds-description {
    width: 837px;
    font-weight: 400;
    font-size: 16px;
    line-height: 28px;
    color: #173945;
}
.sounds-audio {
    width: 513px !important;
}

@media only screen and (max-width: 414px) {
    .sounds-description {
        width: 304px;
    }
    .sounds-audio { width: 90% !important };
}
</style>
